export const getAuthUser = state => state.app.auth.user;

export const getAccounts = state => getAuthUser(state).accounts;
export const getBusinessUnit = state => getAuthUser(state).businessId;
